/**
 * matchRule
 * @param str string to check with the rule
 * @param rule is the rule you apply to the string with * wild card, like "exaple*" return a boolean
 */
export function matchRule(str: string, rule: string) {
    const escapeRegex = (currentString: string) => currentString.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, '\\$1');
    return new RegExp('^' + rule.split('*').map(escapeRegex).join('.*') + '$').test(str);
}

/**
 * get from path
 * @param object is the object to query
 * @param path a string or an array that define a path of object interrogation
 * @param defaultVal if no value is selected return the default value
 */
export function get(object: any, path: Array<any> | string, defaultVal: any = null): any {
    path = Array.isArray(path) ? path : path.replace(/(\[(\d)\])/g, '.$2').split('.');
    object = object[path[0]];
    if (object && path.length > 1) {
        return this.__get(object, path.slice(1), defaultVal);
    }
    return object === undefined ? defaultVal : object;
}

/**
 * set from path
 * @param object is the object to query
 * @param path a string or an array that define a path of object interrogation
 * @param val the value to insert
 */
export function set(object: any, path: Array<any> | string, val: any) {
    path = Array.isArray(path) ? path : path.split('.');
    if (path.length > 1) {
        object[path[0]] = object[path[0]] || {};
        return set(object[path[0]], path.slice(1), val);
    }
    object[path[0]] = val;
}

/**
 * size
 * @param object
 */
export function size(object) {
    return Object.keys(object).length;
}

/**
 * Remove null or undefined from object
 * @param object the object to be cleaned
 */
export function cleanObject(object: any) {
    for (let key in object) {
        if (object.hasOwnProperty(key)) {
            if (object[key] === null || object[key] === undefined) {
                delete object[key];
            }
        }
    }
    return object;
}

/**
 * Deep clone an array or an object
 * @param entity array or object to deepclone
 */
export function deepClone(entity: any) {
    if (Array.isArray(entity)) {
        return [...entity.map((v) => deepClone(v))];
    } else if (entity && typeof entity == 'object') {
        const newObj = {};
        for (const key in entity) {
            if (entity.hasOwnProperty(key)) {
                newObj[key] = deepClone(entity[key]);
            }
        }
        return newObj;
    } else {
        return entity;
    }
}